import React, { useEffect } from 'react';
import { scrollTo } from '../../../utils/common';
import { ErrorNotification } from '@cb/apricot-react';
import { IErrorMessagesProps } from './types';

const ErrorMessages: React.FC<IErrorMessagesProps> = ({ errorMessages = [], scrollableWindowId = '' }) => {
  const errorHeadingId = 'generalInfoFormErrorBlock';

  useEffect(() => {
    if (errorMessages.length) {
      const errorHeading = document.getElementById(errorHeadingId);
      if (errorHeading) {
        errorHeading.setAttribute('tabIndex', '-1');
        scrollTo(errorHeadingId, scrollableWindowId);
      }
    }
    // eslint-disable-next-line
  }, [errorMessages]);

  if (!errorMessages.length) {
    return null;
  }

  function clickHandler(e: React.MouseEvent<HTMLElement>) {
    e && e.preventDefault && e.preventDefault();

    const id = e.currentTarget.getAttribute('href')?.substring(1);
    if (id) {
      scrollTo(id, scrollableWindowId);
    }
  }

  return (
    <ErrorNotification title='Submission Error' notificationId={errorHeadingId}>
      <>
        <p id='error-list-title'>List of Errors:</p>
        <ul className='cb-list-style'>
          {[...errorMessages]
            .filter((item) => item.errorMessage)
            .map(({ key, uiName, errorMessage }, index) => (
              <li key={`${key}-${index}-link`} className='tdtk-error-link'>
                <a href={`#${uiName}`} id={`${uiName}-error-link`} onClick={clickHandler}>
                  {errorMessage}
                </a>
              </li>
            ))}
        </ul>
      </>
    </ErrorNotification>
  );
};

export default ErrorMessages;
